import React, { useState, useEffect, useCallback } from 'react';
import { customFields } from '../../utils/api/customFields';

const CustomFieldsSection = ({ coinId, refreshTrigger }) => {
  const [customFieldValues, setCustomFieldValues] = useState({});
  const [loading, setLoading] = useState(true);

  const loadCustomFields = useCallback(async () => {
    try {
      const values = await customFields.getValues(coinId);
      setCustomFieldValues(values);
    } catch (err) {
      console.error('Error loading custom fields:', err);
    } finally {
      setLoading(false);
    }
  }, [coinId]);

  useEffect(() => {
    loadCustomFields();
  }, [loadCustomFields, refreshTrigger]);

  const parseValue = (value) => {
    if (!value) return '-';
    try {
      // If it's a JSON string, parse it
      const parsed = JSON.parse(value);
      return parsed.value || '-';
    } catch (e) {
      // If it's not JSON, return as is
      return value;
    }
  };

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="px-4 py-5 sm:px-6 border-b border-gray-200 bg-gray-50">
          <h3 className="text-lg font-medium leading-6 text-gray-900">Custom Fields</h3>
        </div>
        <dl className="divide-y divide-gray-200">
          <div className="bg-white px-4 py-3 flex items-center sm:px-6">
            <dt className="text-sm font-medium text-gray-500 w-32 flex-shrink-0">Loading...</dt>
            <dd className="text-sm text-gray-900 ml-2">-</dd>
          </div>
        </dl>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200 bg-gray-50">
        <h3 className="text-lg font-medium leading-6 text-gray-900">Custom Fields</h3>
      </div>
      <dl className="divide-y divide-gray-200">
        {Object.entries(customFieldValues).map(([fieldId, field], index) => (
          <div key={fieldId} className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} px-4 py-3 flex items-center sm:px-6`}>
            <dt className="text-sm font-medium text-gray-500 w-32 flex-shrink-0">{field.name}</dt>
            <dd className="text-sm text-gray-900 ml-2">
              {parseValue(field.value)}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
};

export default CustomFieldsSection;
